import React, { Component } from 'react';

export default class Loader extends Component {
    render() {
        let style = {
            display: this.props.isVisible ? 'block' : 'none'
        };
        return (
            <div style={style} className="loader">
                <i className="fa fa-money"></i>
                <i className="fa fa-money"></i>
            </div>
        );
    };
}


// WEBPACK FOOTER //
// ./src/components/Loader.js